import { useAppSelector } from 'store/hooks';
import { selectSetupStepCount } from '../cohort';
export const useSetupStepLabel = (step) => {
    const total = useAppSelector(selectSetupStepCount);
    return `Complete setup ${step}/${total}`;
};
